import Vue from "vue";
import Router from "vue-router";
import Frame from './views/Frame.vue';

Vue.use(Router);

function _import(view) {
  return () => import('@/views/' + view);
}

const routes = [
  {
    path: '/',
    component: Frame, 
    children: [
      {path: '', redirect: 'home'},
      {path: 'home', component: _import('home/Home'), meta: {title: '首页'}},
      {path: 'model', component: _import('model/Model'), meta: {title: '作品'}},
      {path: 'pavilion', component: _import('pavilion/Pavilion'), meta: {title: '展馆'}},
      {path: 'user', component: _import('user/My'), meta: {title: '我的'}}
    ]
  },
  {
    path: '/login',
    component: _import('Login'),
    meta: {title: '登录'}
  },
  {
    path: '/model-view/:id',
    component: _import('ModelView'),
    meta: {title: '3D模型'}
  },
  {
    path: '/pavilion-view/:id',
    name: 'pavilion-view',
    component: _import('PavilionView'),
    meta: {title: '3D展馆'}
  },
  {
    path: '/try-on/:id',
    name: 'try-on',
    component: _import('tryOn'),
    meta: {title: '试戴'}
  },
  {
    path: '/all-model',
    component: _import('AllModel'),
    meta: {title: '全部模型'}
  },
  {
    path: '/fans-list',
    component: _import('FansList'),
    meta: {title: '粉丝'}
  },
  {
    path: '/personal-data',
    component: _import('PersonalData'),
    meta: {title: '个人资料'}
  },
  {
    path: '/edituser',
    component: _import('user/editUser'),
    meta: {title: '修改用户信息'}
  },
  {
    path: '/search',
    component: _import('search'),
    meta: {title: '搜索'}
  },
  {
    path: '/searchResult',
    component: _import('searchResult'),
    meta: {title: '搜索结果'}
  },
  {
    path: '/visit-info',
    component: _import('visitInfo'),
    meta: {title: '用户访问数据'}
  },
  {
    path: '/public-hall',
    component: _import('publicHall'),
    meta: {title: '我发布的展馆'}
  },
  {
    path: '/preview-album/:id',
    component: _import('previewAlbum'),
    meta: {title: '图集'}
  }
]

const router =  new Router({
  mode: "hash",
  // base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title || '';
  if (title) {
    document.title = title;
  }
  next();
});

export default router